<template>
    <div id="sh011" class="sh011" v-cloak>
        <!-- パンくずリスト -->
        <template v-if="!loginHissuFlg">
            <breadcrumb :decriptPage="$t('common.labels.login')"></breadcrumb>
        </template>

        <div>
            <!-- ログイン -->
            <div class="itemTitle">
                <h2>{{$t('common.labels.login')}}</h2>
            </div>
            <template v-if="logoImg != null && logoImg != ''">
                <div class="sh011logoImgDiv">
                    <img :src="logoImg" :alt="imgDetail" class="sh011LogoImg"/>
                </div>
            </template>
            <div class="section-inner">
                <h3 class="sectionTitle">{{$t('sh011.labels.loginPart')}}</h3>
                <!--ログインメッセージ-->
                <p class="loginInfo" v-if="!loginHissuFlg">
                    {{$t('sh011.labels.msgLogin[0]')}}<br />{{$t('sh011.labels.msgLogin[1]')}}
                </p>

                <div class="loginForm">
                    <!--ログインIDの場合-->
                    <h4 >{{sh011Init.loginIdNm}}{{$t('sh011.labels.confirmLogin')}}</h4>
                    <!--エラーメッセージ表示枠-->
                    <div v-if="mapMessValid.length > 0 || listMessValid.length > 0" class="error-message">
                        <!-- 入力に誤りがあります。内容をご確認ください -->
                        <p>
                            <template v-if="$t('sh011.labels.msgShowErr') != ''">
                                {{$t('sh011.labels.msgShowErr')}}<br>
                            </template>
                            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'sh011'"/>
                        </p>
                    </div>
                    <dl class="loginId">
                        <!-- メールアドレス -->
                        <dt>
                            <span id="mailAddress_lbl">{{sh011Init.loginIdNm}}</span>
                        </dt>
                        <dd>
                            <input-check v-model="sh011Request.mailAddress" class="mail" id="mailAddress" maxlength="80" tabindex=1 type="text"/>
                        </dd>
                        <!--ID保存オプション-->
                        <template v-if="isSaveCookie">
                            <div>
                                <dt><span></span></dt>
                                <dd>
                                    <input type="checkbox" v-model="isSave" tabindex=2>
                                    <template >
                                        {{sh011Init.loginIdNm}}{{$t('sh011.labels.saveMailAddr')}}
                                    </template>
                                </dd>
                                <dd v-if="sh011Init.loginIdNmOption == 9">
                                    ※ログインID、またはメールアドレスを入力してください
                                </dd>
                            </div>
                        </template>
                        <template v-else>
                            &nbsp;&nbsp;
                        </template>
                    </dl>
                    <dl class="loginPass">
                        <!-- パスワード -->
                        <dt><span>{{$t('common.labels.password')}}</span></dt>
                        <dd>
                            <input-check v-model="sh011Request.password" maxlength="30" id="password" tabindex=3 type="password"/>
                        </dd>
                    </dl>
                    <div class="loginBtn">
                        <!-- ログインボタン -->
                        <a class="btnSubmit" href="javascript:void(0)" @click="doLogin();" tabindex=4>{{$t('common.buttons.login')}}</a>
                    </div>
                    <ul class="loginLink">
                        <!--パスワードリマインダーオプション-->
                        <li v-if="reminderFlg" class="passReminder">
                            <!-- パスワードを忘れた方 -->
                            <router-link :to="generateLinkParams(14, sh011Init.passRemindPage, {}, { fromCart: sh011ModeModel.fromCart, guestEntry: sh011Init.guestEntry, returnFlg: sh011ModeModel.returnFlg, mailAddress: sh011Request.mailAddress })" tabindex=5>
                                {{$t('common.labels.getPassword')}}
                            </router-link>
                        </li>
                        <li class="newCustomer">
                            <!-- 新規会員登録 -->
                            <router-link :to="generateLinkParams(8, sh011Init.customerPage, {}, { fromCart: sh011ModeModel.fromCart })" tabindex=6>
                                {{$t('sh011.labels.registerMember')}}
                            </router-link>
                        </li>
                        <!--初回ログインオプション-->
                        <li v-if="firstTimeAccessFlg" class="firstLogin">
                            <!-- 初回ログイン登録へ -->
                            <router-link :to="{ name: SiteConstants.PG010MAIN, query: {pageNo: 100}, params: {fromCart: sh011ModeModel.fromCart} }" tabindex=7>
                                {{$t('sh011.labels.firstTimeAccess')}}
                            </router-link>
                        </li>
                    </ul>
                    <!--未ログインでカートから遷移した場合-->
                    <template v-if="sh011ModeModel.fromCart == 1 && sh011Init.guestEntry == 0 && sh011Init.cardTeikiItemCnt == 0">
                        <!-- 会員登録をしないでお買いものをする方 -->
                        <h4 v-html="descriptionInfo[1]" @click="handleLineClick"></h4>
                        <div class="loginGuest">
                            <!-- ゲスト購入 -->
                            <span id="guestMsg" v-html="descriptionInfo[2]" ></span>
                        </div>
                    </template>
                    <!--未ログインでカートから遷移した場合-->
                    <template v-if="sh011ModeModel.fromCart == 1 && sh011Init.guestEntry == 0 && sh011Init.amazonCheckoutSessionId  == null && sh011Init.amazonPayFlg == '1'">
                        <h4 style="margin-top:12px;">または<br/><span style="margin-top:12px;size: 40px;">外部IDを利用</span></h4>
                        <div  style="text-align:center ;height: 100%;display: flex;align-items: center;justify-content: center;"><div id="AmazonPayButton"/></div>
                    </template>
                </div><!--/ .login-form -->
            </div>
        </div>
        <alert-confirm 
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :cancelAction="cancelAction"
            :size="'lg'"
            @closedModal="isModalShow = false"
        />
    </div>
</template>
<script>
import common from 'assets/js/common';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import AlertConfirm from 'components/AlertConfirm';

export default {
    name: "SH011ShopperLogin",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    components:{
        InputCheck,
        Message,
        Breadcrumb,
        AlertConfirm
    },
    data() {
        return {
            SH011_PART: 'sh011',
            isLoading: false,
            isSaveCookie: false,
            isSave: false,
            sh011ModeModel:{
                nextPage: null,
                fromCart: null,
                returnFlg: null,
            },
            sh011Request:{
                mailAddress: '',
                password: '',
                shahanFlg: '',
            },
            sh011Init:{
                shahanFlg: null,
                guestEntry: null,
                url: null,
                contextPath: null,
                serverName: null,
                loginIdFlg: 0,
                descriptionInfo:{},
                loginIdNm: null,
                amazonCheckoutSessionId:null,
            },
            doLoginResp: null,

            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            SiteConstants: SiteConstants,
            site: "",
            reminderFlg : false,
            loginHissuFlg : true,
            firstTimeAccessFlg : false,

            isModalShow: false,
            confirmActionFlg: 0,
            msgConfirm: null,
            descriptionInfo:[],
            logoImg:null,
            imgDetail:null,
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            //set data init
            _this.sh011Init = _this.ptInitData;
            //項目説明
            _this.descriptionInfo = _this.sh011Init.descriptionInfo;
            // ログイン必須オプションフラグ 0:任意 1:必須
            if (_this.sh011Init.loginHissuFlg == 1) {
                _this.loginHissuFlg = true;
            } else {
                _this.loginHissuFlg = false;
            }
            // パスワードリマインダーオプションフラグ 0:利用しない 1:利用する
            if (_this.sh011Init.reminderFlg == 1) {
                _this.reminderFlg = true;
            }
            // 初回アクセス会員登録利用オプションフラグ 0:利用しない 1:利用する
            if (_this.sh011Init.firstTimeAccessFlg == 1) {
                _this.firstTimeAccessFlg = true;
            }
            // ID保存オプション利用の場合 0:利用しない 1:利用する
            if (_this.sh011Init.loginIdSaveFlg == 1) {
                _this.isSaveCookie = true;
                var idSaveKbn = _this.getCookie("idSaveKbn");
                var loginMail = _this.getCookie("loginMail");
                // IDを保存している場合
                if(idSaveKbn == 1){
                    _this.sh011Request.mailAddress = loginMail;
                    _this.isSave = true;
                }else{
                    _this.sh011Request.mailAddress = '';
                    _this.isSave = false;
                }
            }

             // ログイン済の場合
            if(_this.sh011Init.isLogin == true && !_this.sh011ModeModel.token){
                //TOPページへ遷移
                const parameter = _this.generateLinkParams(1,_this.sh011Init.topPage);
                _this.$router.push(parameter);
            }
            if(_this.sh011Init.url != null && _this.sh011Init.url != undefined && _this.sh011Init.url != ''){
                var domain = _this.sh011Init.url.replace("https://","").replace("http://","");
                if(domain != _this.sh011Init.serverName){
                    window.location.replace(_this.sh011Init.url + _this.sh011Init.contextPath + '/')
                }
            }

           // トークンありだった場合
            if (_this.sh011ModeModel.token) {
                // ログイン情報の取得
                _this.getLoginInfo(_this.sh011ModeModel.token);
            }

            // ECサイトロゴマスタに登録があるか確認
            if (_this.sh011ModeModel.logoToken) {
                // ECサイトロゴマスタ情報の取得
                _this.getLogoInfo(_this.sh011ModeModel.logoToken);
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.DO_INIT,_this.sh011Request).then(function(response) {
                //set data init
                _this.sh011Init = response.data;
                //項目説明
                _this.descriptionInfo = _this.sh011Init.descriptionInfo;
                // ログイン必須オプションフラグ 0:任意 1:必須
                if (_this.sh011Init.loginHissuFlg == 1) {
                    _this.loginHissuFlg = true;
                } else {
                    _this.loginHissuFlg = false;
                }
                // パスワードリマインダーオプションフラグ 0:利用しない 1:利用する
                if (_this.sh011Init.reminderFlg == 1) {
                    _this.reminderFlg = true;
                }
                // 初回アクセス会員登録利用オプションフラグ 0:利用しない 1:利用する
                if (_this.sh011Init.firstTimeAccessFlg == 1) {
                    _this.firstTimeAccessFlg = true;
                }
                // ID保存オプション利用の場合 0:利用しない 1:利用する
                if (_this.sh011Init.loginIdSaveFlg == 1) {
                    _this.isSaveCookie = true;
                    var idSaveKbn = _this.getCookie("idSaveKbn");
                    var loginMail = _this.getCookie("loginMail");
                    // IDを保存している場合
                    if(idSaveKbn == 1){
                        _this.sh011Request.mailAddress = loginMail;
                        _this.isSave = true;
                    }else{
                        _this.sh011Request.mailAddress = '';
                        _this.isSave = false;
                    }
                }
                // ログイン済の場合
                if(_this.sh011Init.isLogin == true){
                    //TOPページへ遷移
                    const parameter = _this.generateLinkParams(1,_this.sh011Init.topPage);
                    _this.$router.push(parameter);
                }
                if(_this.sh011Init.url != null && _this.sh011Init.url != undefined && _this.sh011Init.url != ''){
                    var domain = _this.sh011Init.url.replace("https://","").replace("http://","");
                    if(domain != _this.sh011Init.serverName){
                        window.location.replace(_this.sh011Init.url + _this.sh011Init.contextPath + '/')
                    }
                }
                
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 画面上部にAmazonPayボタンを表示(0だったら非表示)
        if (_this.sh011Init.amazonPayFlg == '1'  && _this.sh011Init.amazonCheckoutSessionId == null) {
            var amazonCheckoutSessionId = _this.$router.history.current.fullPath.split("amazonCheckoutSessionId=")[1];
            if  (amazonCheckoutSessionId != null) {
                _this.sh011Init.amazonCheckoutSessionId = amazonCheckoutSessionId;
            }
            // Dynamically load the Amazon Pay SDK script
            const script = document.createElement('script');
            script.src = 'https://static-fe.payments-amazon.com/checkout.js';
            script.async = true;
            document.head.appendChild(script);
            // Wait for the script to be loaded before rendering the button
            script.onload = () => {
                // Check if the AmazonPay object is available
                amazon.Pay.renderButton('#AmazonPayButton', {
                    // set checkout environment
                    merchantId: _this.sh011Init.merchantId,
                    ledgerCurrency: 'JPY',             
                    // customize the buyer experience
                    checkoutLanguage: 'ja_JP',
                    productType: 'PayAndShip',
                    placement: 'Checkout',
                    buttonColor: 'Gold',
                    // configure Create Checkout Session request
                    createCheckoutSessionConfig: {        
                        payloadJSON: _this.sh011Init.payloadJson,
                        signature: _this.sh011Init.signature, 
                        publicKeyId: _this.sh011Init.publicKeyId
                    }   
                });
            };
        }
        // set return flg
        if(_this.sh011ModeModel.returnFlg != 1){
            _this.sh011ModeModel.returnFlg = 2;
        }
        window.addEventListener('keyup', this.addEvent);
    },
    methods: {
        /*
        * add listner 
        */
        addEvent(event){
            // エンターキー
            if (event.keyCode === 13) { 
                this.doLogin();
            }
        },
        /*
        * cookieにID保存処理
        */
        saveCookie: function(){
            var _this = this;
            var isSave = 0;
            var loginMail = '';
            // ID保存オプション利用
            if(_this.isSaveCookie){
                // ID保存チェックの場合
                if(_this.isSave == true){
                    isSave = 1;
                    loginMail = _this.sh011Request.mailAddress;
                }
                _this.setCookie('idSaveKbn', isSave, 365);
                _this.setCookie('loginMail', loginMail, 365);
            }
        },
        /*
        * ログイン処理
        */
        doLogin: function(){
            var _this = this;
            // ID保存処理
            _this.saveCookie();
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH011_PART);
            _this.sh011Request.orderCdTypical = _this.sh011ModeModel.orderCdTypical;
            _this.sh011Request.kokyakuNo = _this.sh011ModeModel.kokyakuNo;
            _this.sh011Request.fBaFLG = _this.sh011ModeModel.fBaFLG;
            // Call API login
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.LOGIN, _this.sh011Request).then(function(response) {
                _this.doLoginResp = response.data;

                let loginProblem = response.data.loginProblem;
                let loginMsg = response.data.loginMsg;
                if (loginProblem == "ERROR_LAST_LOGIN_DATE") {
                    _this.listMessValid.push(loginMsg);
                    _this.$emit("event-loading", false);
                    return;
                } else if (loginProblem == "WARN_EXPIRED_PASSWORD") {
                    _this.showConfirmChangePass(loginMsg);
                    _this.$emit("event-loading", false);
                    return;
                } else if (loginProblem == "ERROR_EXPIRED_PASSWORD") {
                    _this.gotoChangePassScreen();
                    _this.$emit("event-loading", false);
                    return;
                } else if (_this.doLoginResp.catalogFlg == 1 && _this.doLoginResp.orderStatusByHagaki > 0) {
                    location.href = _this.doLoginResp.moveUrl;
                    _this.$emit("event-loading", false);
                    return;
                } else if (_this.doLoginResp.zenkaiShouhinFlg == 1) {
                    if(_this.doLoginResp.unicoCartOptFlg == 1){
                        _this.doInsertAddedProduct();
                        _this.$emit("event-loading", false);
                        return;
                    }else{
                        _this.showConfirmSaveShowhin();
                        _this.$emit("event-loading", false);
                        return;
                    }
                } else if (_this.doLoginResp.entetsuHojinChangePsdFlg == 1) {
                    _this.gotoChangePassScreen();
                    _this.$emit("event-loading", false);
                    return;
                }

                _this.gotoOtherScreen();
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH011_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        handleLineClick(e) {
            let clickedElId = e.target.id;
            if (clickedElId === 'guestMsg') {
                this.doNoLogin();
            } 
        },
        /*
        * ゲスト購入の場合の処理
        */
        doNoLogin: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            // Call API nologin
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.DO_NO_LOGIN).then(function(response) {
               //TODO: check status login
                if(response.data.status == "OK"){
                    // 届先指定画面へ遷移
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 19}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * 前回すでに追加された商品の追加
        */
        doInsertAddedProduct: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            // Call API nologin
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.ADDED_SHOUHIN_INS).then(function(response) {
               //TODO: check status login
               if(response.data.status == "OK" && _this.doLoginResp.unicoCartOptFlg == 1){
                    // TOPページへ遷移
                    const parameter = _this.generateLinkParams(1,_this.sh011Init.topPage);
                    _this.$router.push(parameter);
                }
                else if(response.data.status == "OK"){
                    // カートの確認画面へ遷移
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /*
        * トークンによるログイン情報の取得
        */
       getLoginInfo: function(token){
            var _this = this;
            _this.$emit("event-loading", true);
            // Call API get login info
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.GET_LOGIN_INFO, {
                token: token
            }).then(function(response) {
                if (response && response.data) {
                    _this.sh011Request.mailAddress = response.data.mailAddress;
                    _this.sh011Request.password = response.data.password;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            }).finally(function() {
                _this.$emit("event-loading", false);
            });
        },
        /*
        * ECサイトロゴマスタ情報の取得
        */
       getLogoInfo: function(logoToken){
            var _this = this;
            _this.$emit("event-loading", true);
            // Call API get login info
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.GET_LOGO_INFO, {
                logoToken: logoToken
            }).then(function(response) {
                if (response && response.data) {
                    _this.logoImg = response.data.logoImg;
                    _this.imgDetail = response.data.imgDetail;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            }).finally(function() {
                _this.$emit("event-loading", false);
            });
        },

        /**
        * cookie情報を取得
        * @param {String} cname, cookie name
        **/
        getCookie: function(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        /**
        * cookieに情報をセット
        * @param {String} cname, cookie name
        * @param {String} cvalue, cookie value
        * @param {String} exdays, cookie expires
        **/
        setCookie: function(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + "Secure;" + expires;
        },

        showConfirmChangePass: function(message) {
            var _this = this;

            _this.msgConfirm = message + "<br/>" + _this.$i18n.t('common.messages.confirmChangePass');
            _this.confirmActionFlg = 1;
            _this.isModalShow = true;
        },
        showConfirmSaveShowhin: function() {
            var _this = this;

            _this.msgConfirm = _this.$i18n.t('common.messages.addedShouhinAdd');
            _this.confirmActionFlg = 2;
            _this.isModalShow = true;
        },

        doAction: function(){
            var _this = this;

            switch (_this.confirmActionFlg) {
                case 1:
                    // Go to change password screen
                    _this.gotoChangePassScreen();
                    break;
                case 2:
                    _this.doInsertAddedProduct();
                    break;
                default:
                    null;
            }

            // Hide alert confirm 
            _this.isModalShow = false;
            _this.confirmActionFlg = 0;
        },

        cancelAction: function() {
            var _this = this;

            switch (_this.confirmActionFlg) {
                case 1,2:
                    _this.gotoOtherScreen();
                    break;
                default:
                    null;
            }
            _this.confirmActionFlg = 0;
        },

        gotoOtherScreen: function() {
            var _this = this;

            // TOPページへ遷移
            if (_this.doLoginResp.isLogin == true) {
                const parameter = _this.generateLinkParams(1,_this.sh011Init.topPage);
                _this.$router.push(parameter);
            // 注文内容確認へ遷移
            } else if(_this.sh011ModeModel.fromCart == 1) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
            // 購入履歴へ遷移
            } else if(_this.sh011ModeModel.fromCart == 88) {
                const parameter = _this.generateLinkParams(9,_this.sh011Init.orderHisPage);
                _this.$router.push(parameter);
            // マイページへ遷移
            } else if(_this.sh011ModeModel.returnFlg == 1) {
                const parameter = _this.generateLinkParams(81,_this.sh011Init.myPage);
                _this.$router.push(parameter);
            // 初回ログインの場合
            } else if (_this.doLoginResp.firstLoginFlg == 1) {
                // パスワードリマインダー画面へ遷移
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 15, k: _this.doLoginResp.uuid, firstLoginFlg: _this.doLoginResp.firstLoginFlg}});
            // 商品詳細ページからログインページにジャンプし、ログイン成功すると商品詳細ページに戻ります。
            } else if (_this.sh011ModeModel.fromCart == 3) {
                this.$router.go(-1);
            } else {
                // TOPページへ遷移
                const parameter = _this.generateLinkParams(1,_this.sh011Init.topPage);
                _this.$router.push(parameter);
            }
        },

        gotoChangePassScreen: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.SiteConstants.CHANGE_PASSWORD_PAGE }});
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
    },
    destroyed: function() {
        window.removeEventListener('keyup', this.addEvent)
    },
    created(){
        var _this = this;
        // Get data from params and query
        var queryData = _this.$route.query;
        if(Object.keys(queryData).length > 0){
            _this.sh011ModeModel = queryData;
        }
    }
}
</script>